import React from 'react';
interface ChevronAccentProps {
  /** Direction the chevron points */
  direction?: 'right' | 'left' | 'up' | 'down';
  /** Size in pixels */
  size?: number;
  /** Single color or use brand palette */
  color?: 'navy' | 'seaglass' | 'teal' | 'sage';
  /** Whether to show as a double chevron */
  double?: boolean;
  className?: string;
}
/**
 * Extracted chevron/arrow accent from the GTH brand language.
 * Use as section dividers, inline ornaments, or directional cues.
 * Like a dingbat in editorial typography.
 */
export function ChevronAccent({
  direction = 'right',
  size = 48,
  color = 'seaglass',
  double = false,
  className = ''
}: ChevronAccentProps) {
  const colors: Record<string, string> = {
    navy: '#1A2838',
    seaglass: '#8BA89F',
    teal: '#3D6B7E',
    sage: '#A8C4BB'
  };
  const fill = colors[color];
  const rotations: Record<string, number> = {
    right: 0,
    down: 90,
    left: 180,
    up: -90
  };
  const rotation = rotations[direction];
  return <div className={`pointer-events-none ${className}`} data-id="element-40">
      <svg width={size} height={size} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="none" style={{
      transform: `rotate(${rotation}deg)`
    }} data-id="element-41">
        {/* Primary chevron — angular, architectural */}
        <polygon points="12,4 28,24 12,44 18,44 34,24 18,4" fill={fill} opacity={0.7} data-id="element-42" />
        {double && <polygon points="22,8 35,24 22,40 27,40 40,24 27,8" fill={fill} opacity={0.4} data-id="element-43" />}
      </svg>
    </div>;
}